import { $t } from '@/i18n.js'

export const modalDeletedPostMixin = {
  methods: {
    deleteScheduled () {
      this.$confirm(
        $t('general.calendar.areYouSureYouWantToDeleteYourSchedule'),
        $t('general.calendar.deletionPost'),
        {
          confirmButtonText: $t('general.calendar.acceptedPost'),
          cancelButtonText: $t('general.calendar.refusedPost'),
          type: 'warning'
        }
      ).then(() => {
        try {
          this.isDatePickerVisible = false
          this.$store.dispatch('calendarSocialPosts/deleteScheduled', this.networkEvent)
          this.$message({
            type: 'success',
            message: $t('general.calendar.deletionHasBeenCompleted')
          })
        } catch (e) {
          this.$message({
            type: 'error',
            message: $t('general.calendar.deletionFailed')
          })
        }
      })
    }
  }
}
